import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

// Team dashboard routes
export const teamIntegrationListRoute: InvariantJiraRoute = {
	name: 'eoc-team-integration-list',
	path: '/jira/ops/teams/:teamId/integrations/list',
	exact: true,
};
